import { render, staticRenderFns } from "./MakingWavesBackground.vue?vue&type=template&id=8de3ac9c&scoped=true&"
import script from "./MakingWavesBackground.vue?vue&type=script&lang=js&"
export * from "./MakingWavesBackground.vue?vue&type=script&lang=js&"
import style0 from "./MakingWavesBackground.vue?vue&type=style&index=0&id=8de3ac9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de3ac9c",
  null
  
)

export default component.exports